import { isDefinedNotNull } from "util/objUtil"

export const getMetricsLabel = metric => {
  if (isDefinedNotNull(metric)) {
    return `${metric.count}/${metric.total}`
  }
  return ""
}
